import { useGetSelectedGroupByOption } from '@modules/quantify/hooks';
import { GroupByResponse } from 'generated/graphql';
import { getFieldName } from './useGetQuantifyLink';

export function useGetEqlFieldFromEqlGroupBy(groupBy?: GroupByResponse) {
  return useGetSelectedGroupByOption(getFieldName(groupBy));
}
